export default __webpack_public_path__ + "static/media/note-2.7c31bc9c.svg";